var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#6dbe45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41 35.983c-.76-3.277-2.615-5.566-5.567-6.868-1.65-.717-3.483-1.075-5.501-1.075-3.863 0-7.037 1.46-9.522 4.379-2.484 2.919-3.727 7.308-3.727 13.167 0 5.903 1.346 10.08 4.037 12.532 2.69 2.453 5.75 3.679 9.18 3.679 3.363 0 6.119-.971 8.267-2.913 2.149-1.943 3.473-4.487 3.972-7.634h-11.1v-8.008h19.987v25.749h-6.641L58.785 63c-1.93 2.279-3.667 3.885-5.207 4.818-2.648 1.628-5.903 2.441-9.766 2.441-6.359 0-11.567-2.202-15.625-6.608-4.232-4.427-6.348-10.481-6.348-18.164 0-7.769 2.138-13.997 6.413-18.685 4.275-4.687 9.928-7.03 16.96-7.03 6.098 0 10.997 1.545 14.697 4.638 3.7 3.092 5.821 6.95 6.364 11.572H56.41Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.c8bf9b1c0af404c24c158853d90aa20b.svg";
export { ForwardRef as ReactComponent };